<template>
  <Row>
    <i-col span="12">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
        <FormItem label="真实姓名" prop="realname">
          <i-input v-model="formValidate.realname" placeholder="请输入真实姓名"></i-input>
        </FormItem>
        <FormItem label="电子邮箱" prop="email">
          <i-input v-model="formValidate.email" placeholder="Enter your e-mail"></i-input>
        </FormItem>
        <FormItem label="手机号码" prop="mobile">
          <i-input v-model="formValidate.mobile" placeholder="Enter your e-mail"></i-input>
        </FormItem>
        <FormItem label="密码" prop="password">
          <i-input type="password" v-model="formValidate.password"></i-input>
        </FormItem>
        <FormItem label="重复密码" prop="passwdCheck" v-if="passwdCheck()">
          <i-input type="password" v-model="formValidate.passwdCheck"></i-input>
        </FormItem>
        <FormItem label="角色" prop="role">
          <Select v-model="formValidate.role" multiple style="width:260px">
            <Option v-for="item in roleList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="是否超级管理员" prop="issupper">
          <RadioGroup v-model="formValidate.issupper">
            <Radio label="1">是</Radio>
            <Radio label="0">不是</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
        </FormItem>
      </Form>
    </i-col>
    <i-col span="12"></i-col>
  </Row>
</template>
<script>
import { mapState } from "vuex";
import { admindetail } from "../../api/adminapi";
import { updatecompany_admin, company_rolelist } from "../../api/companyapi";
import openpage from "../../constant/openpage.js";

export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback();
      } else {
        if (this.formValidate.passwdCheck !== "") {
          // 对第二个密码框单独验证
          this.$refs.formValidate.validateField("passwdCheck");
        }
        callback();
      }
    };
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formValidate.password) {
        callback(new Error("两次密码不同"));
      } else {
        callback();
      }
    };
    const validatemobile = (rule, value, callback) => {
      var reg = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("手机格式错误"));
      }
    };
    return {
      params: this.$route.query,
      formValidate: {
        realname: "",
        email: "",
        mobile: "",
        role: "",
        issupper: "",
        password: "",
        passwdCheck: ""
      },
      roleList: [],
      ruleValidate: {
        realname: [
          {
            required: true,
            message: "",
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            message: "邮箱不能为空",
            trigger: "blur"
          },
          { type: "email", message: "请输入正确的邮箱", trigger: "blur" }
        ],
        mobile: [
          {
            required: true,
            message: "请输入电话",
            trigger: "blur"
          },
          { validator: validatemobile, trigger: "blur" }
        ],
        password: [{ validator: validatePass, trigger: "blur" }],
        passwdCheck: [{ validator: validatePassCheck, trigger: "blur" }]
      }
    };
  },
  // computed: mapState({
  //   // 箭头函数可使代码更简练
  //   roleList: state => state.roleList
  // }),
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          debugger;
          this.updateadmin();
        } else {
          this.$Message.error("Fail!");
        }
      });
    },
    updateadmin() {
      let para = this.formValidate;
      para.id = this.params.id;
      para.c;
      if (!this.formValidate.password || this.formValidate.password == "") {
        delete para["password"];
      }
      if (
        !this.formValidate.passwdCheck ||
        this.formValidate.passwdCheck == ""
      ) {
        delete para["passwdCheck"];
      }
      this.$Loading.start();
      updatecompany_admin(para).then(res => {
        this.$Loading.finish();
        var data = res.data;
        if (data.code == 1) {
          this.$Message.success(data.message);
          var _this = this;
          setTimeout(function() {
            var query = { id: _this.company_id };
            openpage("companyadmin", query);
            // _this.$router.push({ path: "/companyadmin" });
          }, 1500);
        } else {
          this.formValidate.password = "";
          this.formValidate.passwdCheck = "";
          this.$Message.error(data.message);
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    passwdCheck() {
      if (this.formValidate.password != "") {
        return true;
      } else {
        return false;
      }
    },
    setparams(data) {
      this.formValidate = {
        company_id: data.company_id,
        id: data.id,
        realname: data.realname,
        email: data.email,
        mobile: data.mobile,
        role: [],
        issupper: data.issupper + ""
      };
      data.role = JSON.parse(data.role);
      if (data.role && data.role.length > 0) {
        data.role.forEach(element => {
          this.formValidate.role.push(element.id);
        });
      }
    },
    getrolelist(_data) {
      let par = {
        company_id: _data.company_id
      };
      company_rolelist(par).then(res => {
        let data = res.data;
        if (data.code == 1) {
          this.roleList = data.data;
          this.setparams(_data);
        }
      });
    }

    // setparams(id) {
    //   var data = {
    //     id: id
    //   };
    //   var _this = this;
    //   admindetail(data).then(res => {
    //     var Data = res.data;
    //     if (Data.code == 1) {
    //       let data = Data.data;
    //
    //       };

    //       data.role.forEach(element => {
    //          _this.formValidate.role.push(element.id)
    //       });
    //     } else {
    //       this.$Message.error(Data.message);
    //     }
    //   });
    // }
  },
  mounted() {
    if (this.$route.query) {
      this.getrolelist(this.$route.query);
      this.company_id = this.$route.query.company_id;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/company/companyadminupdte.vue